import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { islipConfig } from "./data";

export default function IslipPage() {
  return <CityPageTemplate config={islipConfig} />;
}